module.exports = __webpack_public_path__ + "img/icon-circle-arrow.c3974e49.svg";